export default __webpack_public_path__ + "static/media/mody-background.05f2e568.png";